module.exports = __webpack_public_path__ + "static/media/DSC09995.939da0c0.jpg";